import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { ProdFormulaControl } from "../models";

@Injectable({ providedIn: "root" })
export class ProdFormulaControlService {
  private ProdFormulaControlEndPoint = `${environment.rydApiUrl}/api/formula-control`;
  constructor(private _http: HttpClient) {}

  createNewProdFormulaControl(control: ProdFormulaControl) {
    return this._http.post<{ message: String; control: ProdFormulaControl }>(
      this.ProdFormulaControlEndPoint,
      control
    );
  }
  getAllByProdFormulaId(id:number){
   return this._http.get<ProdFormulaControl[]>(this.ProdFormulaControlEndPoint+`/${id}`);
  }

}
